<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <b-container>
        <!--<b-breadcrumb :items="bread" class="mt10"></b-breadcrumb>-->

        <b-alert show variant="danger" class="mt20">
            <div v-html="promptMsg"></div>
        </b-alert>

        <b-row class="mt20">
            <b-col lg="4" xl="4" sm="12" md="4">
                <h5 class="alert-heading">您的申请记录</h5>
            </b-col>

            <b-col lg="2" xl="2" sm="3" md="2">
                <b-form-select v-if="false" v-model="selectedTheme" :options="tableTheme"
                    placeholder="请选择表主题"></b-form-select>
            </b-col>

            <b-col lg="2" xl="2" sm="3" md="2"></b-col>

            <b-col lg="4" xl="4" sm="6" md="4">
                <b-form-select v-model="reqBody.applyNo" :options="years" placeholder="请选择年份"
                    @change="getList(true)"></b-form-select>
            </b-col>
        </b-row>

        <b-spinner variant="primary" label="Spinning" v-if="loading"></b-spinner>

        <h3 v-if="!loading && items.length == 0">未找到相关记录</h3>

        <b-table :sticky-header="stickyHeader" :no-border-collapse="noCollapse" class="mt10" bordered
            style="text-align: left" responsive="sm" striped hover small :items="items" :fields="fields"
            :dark="selectedTheme == 2" v-if="items.length > 0">
            <template v-slot:cell(projName)="data">
                {{ placement }}
                <p class="proj-name" :id="`popover-1-${data.item.key}`">{{ data.item.projName }}</p>
                <b-popover style="background-color: #0f6674" :target="`popover-1-${data.item.key}`" title="项目名称"
                    triggers="hover">
                    <template v-slot:title>项目名称</template>
                    <div style="background-color: #d7edf6; padding: 10px; line-height: 25px">{{ data.item.projName }}
                    </div>
                </b-popover>
            </template>

            <template v-slot:cell(operate)="data">
                <b-button v-if="!data.item.queTime" style="padding: 2px; width: 60px; margin-left: 5px"
                    @click="toFormPage(data.item)" size="sm" :disabled="disableQuest || !data.item.canEdit"
                    variant="outline-primary">填写</b-button>

                <b-button v-else style="padding: 2px; width: 60px; margin-left: 5px" @click="toFormPage(data.item)"
                    size="sm" :disabled="disableQuest || !data.item.canEdit" variant="outline-primary">修改</b-button>

                <b-button style="padding: 2px; width: 60px; margin-left: 5px" @click="toFormPage(data.item, '999')"
                    size="sm" variant="outline-primary">查看</b-button>

                <b-button style="padding: 2px; width: 125px; margin-left: 5px; margin-top: 5px"
                    @click="downPdf(data.item)" size="sm" variant="outline-primary"
                    :disabled="disableQuest || !data.item.fileName">首席简表PDF</b-button>
                <!--  -->
            </template>

            <template v-slot:cell(status)="data">
                <b-badge variant="primary" v-if="data.item.queTime">已填写</b-badge>
                <b-badge variant="secondary" v-else>未填写</b-badge>

                <b-badge v-if="!data.item.canEdit" variant="danger">已超时</b-badge>
            </template>
        </b-table>

        <b-pagination v-if="items.length > 0" align="center" class="mt20" :number-of-pages="pagination.totalPage"
            :value="pagination.page" :total-rows="pagination.total" :per-page="reqBody.pageSize" base-url="#"
            first-text="首页" prev-text="上一页" next-text="下一页" last-text="末页" first-number last-number
            @change="pageChangeListener"></b-pagination>

        <link-component></link-component>
    </b-container>
</template>

<script>
import LinkComponent from '../../components/LinkComponent.vue';
import Vue from 'vue';
import { axiosServer } from '@/api/judge';
import { urls } from '@/api/urls';
import { requestCsApplyQuest } from '@/api/SvpConfig';

export default {
    components: { LinkComponent },
    name: 'option',
    props: {},
    computed: {
        years: function () {
            // 获取当前年份
            var date = new Date();
            var year = date.getFullYear();
            var years = [];
            // 生成从2015至今年的年份列表
            for (var i = 2015; i <= year + 2; i++) {
                years.push({ value: i, text: i });
            }
            // 倒序排列
            years.reverse();

            // 在起始位置插入全部年份
            years.unshift({ value: null, text: '全部年份' });

            return years;
        }
    },
    data() {
        return {
            stickyHeader: false,
            noCollapse: false,
            fields: [
                { key: 'applyNo', label: '申请号', stickyColumn: true, isRowHeader: true },
                { key: 'prjNum', label: '项目批准号' },
                { key: 'prjName', label: '项目名称' },
                { key: 'appPerson', label: '项目负责人' },
                // { key: 'ocnArea', label: '海区' },
                { key: 'cruiseName', label: '航次名称' },
                // { key: 'cruiseName', label: '航次名称' },
                { key: 'tenderUnit', label: '投标单位' },
                { key: 'tenderUnitChief', label: '航次首席' },
                { key: 'queTime', label: '提交时间' },
                { key: 'status', label: '状态' },
                { key: 'operate', label: '操作', stickyColumn: true, isRowHeader: true },
            ],
            items: [],

            bread: [
                {
                    text: '首页',
                    href: '/index',
                },
                {
                    text: '首席科学家预评估意见表列表',
                },
            ],

            yearSelected: null,

            selectedTheme: 1,

            tableTheme: [
                { value: '1', text: '白色主题' },
                { value: '2', text: '黑色主题' },
            ],

            reqBody: { page: 1, pageSize: 10, applyNo: null },

            pagination: {},
            promptMsg: '',
            disableQuest: true,
            loading: false,
            expired: true,
        };
    },
    activated() {
        let loginName = Vue.ls.get('username');
        if (!loginName) {
            this.$router.push({
                name: 'login',
                query: { tip: 1, msg: '访问搭载需求征集页面需要先登录', directUrl: 'ChiefScientistOpinion' },
            });
        } else {
            this.getList();
            requestCsApplyQuest().then((resp) => {
                this.promptMsg = resp.content;
                this.disableQuest = resp.expired;
            });
        }
    },
    mounted() { },
    methods: {
        downPdf(item) {
            window.open(item.fileName2, '_blank');
        },
        applyPdf(item) {
            let routeUrl = this.$router.resolve({
                path: '/CsApplyPdf',
                query: { applyId: item.tenderId },
            });
            // window.open(routeUrl.href, '_blank');
            window.open(routeUrl.href, '_blank', 'width=1186px,height=832px,top=0px,left=0px');
        },
        pageChangeListener(page) {
            this.reqBody.page = page;
            this.getList();
        },

        toFormPage(data, code) {
            data.code = code;
            this.$router.push({ name: 'ChiefScientistOpinionForm', query: data });
        },

        getList(isSearchBtnClick) {
            if (isSearchBtnClick) {
                this.reqBody.page = 1;
                this.reqBody.cruiseName = this.keyword;
            }

            axiosServer({
                url: urls.SvpCsQuestionnaire,
                params: this.reqBody, //将参数设置为变量reqBody
            }).then((resp) => {
                let year = resp.data.year;
                resp.data.page.list.forEach((item) => {
                    let itemYear = item.applyNo.substring(0, 4);
                    item.canEdit = itemYear >= year;

                    if (item.fileName) {
                        item.fileName2 = '/cs/' + item.fileName;
                    }
                });
                this.items = resp.data.page.list;
                console.log(this.items);
                let page = resp.data.page;
                this.pagination = {
                    page: page.page + 1,
                    pageSize: page.pageSize,
                    total: page.total,
                    totalPage: page.totalPage,
                };
            });
        },
    },
};
</script>

<style scoped>
.proj-name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 300px;
    padding: 0px;
    margin-bottom: 0px;
}

/* 响应式布局：方案不同屏幕尺寸分别使用不同的CSS样式 */
@media (max-width: 575.99px) {
    .form-style {
        text-align: left;
        width: 100%;
    }

    .botton-row {
        margin-bottom: 20px;
    }
}

@media (min-width: 576px) {
    .form-style {
        text-align: left;
        width: 100%;
    }

    .botton-row {
        margin-bottom: 20px;
    }
}

@media (min-width: 768px) {
    .form-style {
        text-align: left;
        width: 70%;
        margin: 0 auto;
    }

    .botton-row {
        margin-bottom: 20px;
        padding: 0 50px;
    }
}

@media (min-width: 992px) {
    .form-style {
        text-align: left;
        width: 70%;
        margin: 0 auto;
    }

    .botton-row {
        margin-bottom: 20px;
        padding: 0 100px;
    }
}

@media (min-width: 1200px) {
    .form-style {
        text-align: left;
        width: 70%;
        margin: 0 auto;
    }

    .botton-row {
        margin-bottom: 20px;
        padding: 0 200px;
    }
}
</style>
